import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { TrustTaxCategory } from '../../../shared/types/TrustTaxCategory';
import { Constants } from '../../../shared/utilities/Constants';
import { selectTrustTaxCategoriesFromInquiry, selectTrustTaxCodesFromInquiry } from '../../../transaction-view/reducers';
import { PtrsInfo } from '../../models';
import { selectIsFromEditSubmittedTransaction, selectPtrsInfo, selectTrustIncomePercent, selectTrustIncomeToPercent, selectTrustPrincipalPercent, selectTrustPrincipalToPercent, selectTrustTaxCategories, selectTrustTaxCodes } from '../../reducers';
import { AchTransactionDetailsForm, CheckTransactionDetailsForm, ItTransactionDetailsForm, WireTransactionDetailsForm } from '../../models/form/TransactionFormGroup';

@Component({
  standalone: false,
  selector: 'mm-trust-fields',
  templateUrl: './trust-fields.component.html',
  styleUrls: ['./trust-fields.component.scss']
})
export class TrustFieldsComponent implements OnInit, OnDestroy {
  @Input() parentForm: FormGroup<CheckTransactionDetailsForm | WireTransactionDetailsForm | ItTransactionDetailsForm | AchTransactionDetailsForm>;
  @Input() showPaidFor: Boolean;
  @Input() availableCash: number;
  @Input() datePickerControlName: string;
  @Input() overdraftRulesFutureDate: Date;
  @Input() displayToTrustFields: Boolean = false;
  @Input() displayFromTrustFields: Boolean = true;
  destroy$: Subject<boolean> = new Subject();
  taxCategories$: Observable<TrustTaxCategory[]>;
  taxCodes$: Observable<string[]>;
  trustIncomePercent$: Observable<string>;
  trustPrincipalPercent$: Observable<string>;
  trustIncomeToPercent$: Observable<string>;
  trustPrincipalToPercent$: Observable<string>;
  ptrsInfo$: Observable<PtrsInfo>;
  readonly trustReceivingAccountCopy = Constants.trustReceivingAccountCopy;
  fromAccountControlNames = {
    trustIncomePercent: 'trustIncomePercent',
    trustPrincipalPercent: 'trustPrincipalPercent'
  };
  toAccountControlNames = {
    trustIncomePercent: 'trustIncomeToPercent',
    trustPrincipalPercent: 'trustPrincipalToPercent'
  };

  constructor(private store: Store) { }

  ngOnInit(): void {
    if (this.displayFromTrustFields) {
      this.trustIncomePercent$ = this.store.select(selectTrustIncomePercent)
      this.trustPrincipalPercent$ = this.store.select(selectTrustPrincipalPercent)

      this.store.select(selectIsFromEditSubmittedTransaction).pipe(takeUntil(this.destroy$)).subscribe((isFromEditSubmittedTransaction) => {
        if (isFromEditSubmittedTransaction) {
          this.taxCategories$ = this.store.pipe(select(selectTrustTaxCategoriesFromInquiry));
          this.taxCodes$ = this.store.pipe(select(selectTrustTaxCodesFromInquiry));
        } else {
          this.taxCategories$ = this.store.pipe(select(selectTrustTaxCategories));
          this.taxCodes$ = this.store.pipe(select(selectTrustTaxCodes));
        }
      });
    }

    this.ptrsInfo$ = this.store.select(selectPtrsInfo)

    if (this.displayToTrustFields) {
      this.trustIncomeToPercent$ = this.store.select(selectTrustIncomeToPercent)
      this.trustPrincipalToPercent$ = this.store.select(selectTrustPrincipalToPercent)
    }
  }

  ngOnDestroy(): void {
    this.parentForm?.removeControl('trustIncomePercent');
    this.parentForm?.removeControl('trustPrincipalPercent');
    this.parentForm?.removeControl('trustIncomeToPercent');
    this.parentForm?.removeControl('trustPrincipalToPercent');
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
